module.exports = __webpack_public_path__ + "img/shipping_type_3.9b052bd.webp";